import React, { useState, useEffect } from 'react';
import { Layout, Menu, Select, Button, Grid } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import {
  LogoutOutlined,
  MenuOutlined,
  LineChartOutlined,
  QrcodeOutlined
} from '@ant-design/icons';
import { Icons } from './Icons';
import { useAuth } from '../contexts/AuthContext';
import '../styles/fonts.css';
import { Drawer } from 'antd';


const { Sider, Content, Header } = Layout;
const { Option } = Select;
const { useBreakpoint } = Grid;
export const SidebarLayout = ({ children }) => {
  const { logout, user, userClients, selectedClient, selectClient } = useAuth();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleClientChange = (value) => {
    const client = userClients.find(c => c.client.id === value);
    selectClient(client);
  };

  const renderMenu = () => {
    const items = [];

    items.push(
      <div key="client-selector" style={{ padding: '0 16px', marginBottom: 16 }}>
        {userClients.length > 0 && (
          <Select
            placeholder="Selecione um cliente"
            style={{ width: '100%' }}
            value={selectedClient?.client?.id}
            onChange={handleClientChange}
          >
            {userClients.map(uc => (
              <Option key={uc.client.id} value={uc.client.id}>
                {uc.client.dsname}
              </Option>
            ))}
          </Select>
        )}
      </div>
    );    if (selectedClient) {items.push(
        <Menu.Item key="general-dashboard" icon={<Icons.PieChartOutlined style={{ fontSize: 16 }} />}>
          <Link to="/general_dashboard">Dashboard Geral</Link>
        </Menu.Item>,
        
        <Menu.Item key="horses" icon={<img src={Icons.horse} alt="Cavalo" style={{ width: 16 }} />}>
          <Link to="/truck_horses">Cavalos</Link>
        </Menu.Item>,
        <Menu.Item key="traylers" icon={<img src={Icons.trayler} alt="Carroceria" style={{ width: 16 }} />}>
          <Link to="/truck_traylers">Carretas</Link>
        </Menu.Item>,        <Menu.Item key="devices" icon={<img src={Icons.device} alt="Dispositivo" style={{ width: 16 }} />}>
          <Link to="/devices">Dispositivos</Link>
        </Menu.Item>,
        <Menu.Item key="qr-nfc-scanner" icon={<QrcodeOutlined style={{ fontSize: 16 }} />}>
          <Link to="/qr-nfc-scanner">Ler QRCode</Link>
        </Menu.Item>,
        <Menu.Item key="device-dashboard" icon={<LineChartOutlined style={{ fontSize: 16 }} />}>
          <Link to="/reports">Relatórios</Link>
        </Menu.Item>,
      );
    }

    if (user?.isAdmin) {
      items.push(
        <Menu.Divider key="divider" />,
        <Menu.Item key="customers">
          <Link to="/customers">Clientes</Link>
        </Menu.Item>,
        <Menu.Item key="status">
          <Link to="/device_status">Tipos de Status</Link>
        </Menu.Item>,
        <Menu.Item key="device-types">
          <Link to="/device_type">Tipos de Dispositivos</Link>
        </Menu.Item>,
        <Menu.Item key="horse-types">
          <Link to="/truck_horse_type">Tipos de Cavalos</Link>
        </Menu.Item>,
        <Menu.Item key="trayler-types">
          <Link to="/truck_trayler_type">Tipos de Carrocerias</Link>
        </Menu.Item>,
        <Menu.Item key="users">
          <Link to="/users">Usuários</Link>
        </Menu.Item>
      );
    }

    items.push(
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout} style={{ color: '#ff4d4f' }}>
        Sair
      </Menu.Item>
    );

    return items;
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isMobile && (
        <Sider
          width={260}
          theme="dark"
          style={{
            background: '#001529',
            position: 'fixed',
            height: '100vh',
            left: 0,
            top: 0,
            overflow: 'auto',
            boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
            zIndex: 1000
          }}
        >
          <div className='logo-text' style={{ padding: 16, color: '#fff', textAlign: 'center', fontWeight: 'bold' }}>
            ZETEK
          </div>
          <Menu theme="dark" mode="inline" style={{ background: 'transparent', borderRight: 'none' }}>
            {renderMenu()}
          </Menu>
        </Sider>
      )}

      {isMobile && (
        <>
          <Button
            icon={<MenuOutlined />}
            type="text"
            onClick={() => setDrawerVisible(drawerVisible => !drawerVisible)}
            style={{
              position: 'fixed',
              top: 16,
              left: 16,
              padding: 20,
              zIndex: 1100,
              backgroundColor: '#001529',
              color: '#fff',
              border: 'none'
            }}
          />

          <Drawer
            title={
              <div className='logo-text' style={{ padding: 16, color: '#fff', textAlign: 'center', fontWeight: 'bold' }}>
                ZETEK
              </div>
            }
            placement="left"
            closable={false}
            open={drawerVisible}

            style={{ backgroundColor: '#001529' }}
          >
            
            <Menu
              mode="inline"
              theme="dark"
              style={{ background: 'transparent', borderRight: 'none' }}
            >
              {renderMenu()}
            </Menu>
          </Drawer>
        </>
      )}

      <Layout style={{ marginLeft: !isMobile ? 250 : 0, transition: 'margin-left 0.2s ease' }}>
        <Content
          style={{
            padding: 24,
            marginTop: 0,
            background: '#fff',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};
